module.exports = Object.freeze({
    NONE: 0,
    DELETED: 1,
    SUSPENDED: 2,
    DRAFT: 3,
    NORMAL: 4,
    PRIVATE: 5,
    PUBLIC: 6,
});